"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProcessUpdates = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const Base_1 = require("./Base");
const ProcessUpdates = ({ fill = "#E6E6E6", size = 32 }) => (react_1.default.createElement(Base_1.Base, { smooth: true, fill: "none", size: size, viewBox: "0 0 32 32" },
    react_1.default.createElement("g", null,
        react_1.default.createElement("path", { fill: fill, opacity: "0", d: "M0,0L32,0 32,32 0,32 0,0z" }),
        react_1.default.createElement("path", { fill: fill, opacity: "0.2", d: "M18,28L14,28 14,4 18,4 18,28z" }),
        react_1.default.createElement("path", { fill: fill, opacity: "1", d: "M13,14.4L19,8.4 19,11.6 13,17.6 13,14.4z M13,23.6L19,17.6 19,14.4 13,20.4 13,23.6z M19,5.6L19,4 13,4 13,11.6 19,5.6z M13,26.4L13,28 19,28 19,20.4 13,26.4z" }))));
exports.ProcessUpdates = ProcessUpdates;
//# sourceMappingURL=ProcessUpdates.js.map